/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ name: NonNullable<unknown> }} Home_Greeting_EveningInputs */



/**
* | output |
* | --- |
* | "Good evening, {name}!" |
*
* @param {Home_Greeting_EveningInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const home_greeting_evening = /** @type {((inputs: Home_Greeting_EveningInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Home_Greeting_EveningInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Guten Abend, ${i?.name}!`)
	return /** @type {LocalizedString} */ (`Good evening, ${i?.name}!`)
});